import routes from './routes';
import { SetRoutes } from 'components';

const InterviewStorePoolsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InterviewStorePoolsPages;
